<template>
    <section class="filters" @click="changeState('filters')">
        <div class="wrap" @click.stop>
            
            <div class="new-close" @click="changeState('filters')">
                <img src="@/assets/images/icons/icon_close.svg">
            </div>
            <div class="filters-block">
                <div class="filters-header">
                    <h3>Тип события</h3>
                </div>
                <div class="filters-body">
                    <div class="filters-item" @click="setFilter('next', 'status')">
                        <div class="button" :class="{active: hasActive('next')}">Предстоящие</div>
                    </div>
                    <div class="filters-item" @click="setFilter('now', 'status')">
                        <div class="button" :class="{active: hasActive('now')}">Активные</div>
                    </div>
                    <div class="filters-item" @click="setFilter('stories', 'status')">
                        <div class="button" :class="{active: hasActive('stories')}">Прошедщие</div>
                    </div>
                </div>
            </div>
            <div class="filters-block">
                <div class="filters-header">
                    <h3>Когда</h3>
                </div>
                <div class="filters-body">
                    <div class="filters-item" @click="setFilter('today', 'time')">
                        <div class="button" :class="{active: hasActive('today')}">Сегодня</div>
                    </div>
                    <div class="filters-item" @click="setFilter('tomorow', 'time')">
                        <div class="button" :class="{active: hasActive('tomorow')}">Завтра</div>
                    </div>
                    <div class="filters-item" @click="setFilter('weekend', 'time')">
                        <div class="button" :class="{active: hasActive('weekend')}">В выходные</div>
                    </div>
                    <div class="filters-item">
                        <!-- <div class="button">Календарь</div> -->
                        <date-picker v-model="calendar" range :editable="false" :placeholder="'Календарь'" @change="setFilter('calendar', 'time', $event)"></date-picker>
                    </div>
                </div>
            </div>
            <!-- <div class="filters-block">
                <div class="filters-header">
                    <h3>Стиль катания</h3>
                </div>
                <div class="filters-body">
                    <div class="filters-item" @click="setFilter('freeride', 'style')">
                        <div class="button" :class="{active: hasActive('freeride')}">Freeride</div>
                    </div>
                    <div class="filters-item" @click="setFilter('donwhill', 'style')">
                        <div class="button" :class="{active: hasActive('donwhill')}">Downhill</div>
                    </div>
                    <div class="filters-item" @click="setFilter('freestyle', 'style')">
                        <div class="button" :class="{active: hasActive('freestyle')}">Freestyle</div>
                    </div>
                </div>
            </div> -->
            <div class="filters-block">
                <div class="filters-header">
                    <h3>Местоположение</h3>
                </div>
                <div class="filters-body">
                    <div class="filters-item">
                        <!-- <div class="button" :class="{active: hasActive('country')}">Страна</div> -->
                        <multiselect v-model="country" :showLabels="false" :options="countries" :label="'name'" placeholder="Страна" @input="setFilter(country, 'country')"></multiselect>
                    </div>
                    <div class="filters-item">
                        <multiselect v-model="city" :showLabels="false" :options="cities" :label="'name'" placeholder="Город" @input="setFilter(city, 'city')"></multiselect>
                    </div>
                </div>
            </div>
            <!-- <div class="filters-block">
                <div class="filters-header">
                    <h3>Компания</h3>
                </div>
                <div class="filters-body">
                    <div class="filters-item" @click="setFilter('old', 'team')">
                        <div class="button" :class="{active: hasActive('old')}">Возраст</div>
                    </div>
                    <div class="filters-item">
                        <multiselect v-model="sex" :showLabels="false" :options="['Мужской', 'Женский']" placeholder="Пол" @input="setFilter(sex, 'sex')"></multiselect>
                    </div>
                    <div class="filters-item">
                        <div class="button" :class="{active: active === 'freeride'}">Опыт катания</div>
                    </div>
                </div>
            </div> -->
            <div class="filters-bottom">
                <p class="filters-finded">Найдено: {{getEventsLength}}</p>
                <div class="button filters-clear" @click="clear()">
                    <p>Очистить</p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'filters',
    components: {
        Multiselect,
        DatePicker
    },
    data () {
        return {
            active: [],
            calendar: null,
            sex: null,
            options: ['list', 'of', 'options'],
            countries: [],
            country: null,
            city: null,
            cities: [],
            c_a: [{
                name: 'Russian Federation',
                new: 'Russia'
            }]
        }
    },
    computed: {
        getEventsLength () {
            return this.$store.getters.getEvents.length
        },
        getActiveSports () {
            return this.$store.getters.getActiveSports
        },
        getTypeEvents () {
            return this.$store.getters.getTypeEvents
        },
        getDate () {
            return this.$store.getters.getDate
        },
        getFilters () {
            return this.$store.getters.getFilters
        },
        getStates() {
            return this.$store.getters.getStates
        },
        getFilteredCountries() {
            return this.countries.map(country => {
                let finded = this.c_a.find(c => c.name == country.name );
                finded ? country.name == finded.name : '';
                return country
            })
        }
	},
    methods: {
        hasActive(filter) {
            return this.getFilters.find(item => item.filter == filter) ? true : false
        },
        async clear () {
            this.city = null
            this.country = null
            this.$store.dispatch('setFilters', [
                { filter: 'next', group: 'status' }, 
                { filter: 'now', group: 'status' }, 
                { filter: 'stories', group: 'status' }
            ])
        },
        async setFilter (filter, group, event) {
            let finded = group == 'time' 
                ? this.getFilters.find(item => item.group === group) 
                : this.getFilters.find(item => item.filter === filter);
            let findedCountry = this.getFilters.find(item => item.group === group);
            
            if (group == 'time') {
                finded && finded.filter === filter 
                    ? this.getFilters.splice(this.getFilters.indexOf(finded), 1)
                    : (
                        this.getFilters.splice(this.getFilters.indexOf(finded), 1),
                        this.getFilters.push({filter: filter, group: group, calendar: event})
                    )
                
                filter == 'calendar' 
                    ? this.getFilters.push({filter: filter, group: group, calendar: event}) 
                    : '';
            } else if (group == 'country'){
                this.cities = await this.$store.dispatch('fetchCities', filter)
                findedCountry 
                    ? this.getFilters.splice(this.getFilters.indexOf(findedCountry), 1) 
                    : '';
                this.getFilters.push({filter: filter, group: group})
            } else if (group == 'city'){
                findedCountry 
                    ? this.getFilters.splice(this.getFilters.indexOf(findedCountry), 1) 
                    : '';
                this.getFilters.push({filter: filter, group: group})
                this.$axios.post('/api/zones/by_code', {country: this.country, region: filter})
                    .then( res => {
                        this.$store.dispatch('setCenter', [res.data.center[1], res.data.center[0]]);
                        this.$store.dispatch('setMapZoom', 7);
                    })
            } else {
                finded 
                    ? this.getFilters.splice(this.getFilters.indexOf(finded), 1) 
                    : this.getFilters.push({filter: filter, group: group});
            }

            this.$store.dispatch('setFilters', this.getFilters)
        },
        changeState (element) {
            this.$store.dispatch('changeState', {element: element, val: false})
        },
        getCityByUser() {
            let hasCity = this.getFilters.find(filter => filter.group == 'city');
            this.city = hasCity ? hasCity.filter : this.city
        },
        setMultiselects() {
            let country = this.getFilters.find(filter => filter.group === 'country');
            country ? this.country = country.filter : ''
            let state = this.getFilters.find(filter => filter.group === 'city');
            state ? this.city = state.filter : ''
            this.setStates(country)
        },
        async setStates(country) {
            this.getStates.length > 0 
                ? this.cities = this.getStates 
                : country
                    ? this.cities = await this.$store.dispatch('fetchCities', country.filter)
                    : ''
        }
    },
    async mounted () {
        this.getCityByUser()
        this.setMultiselects()
        
    },
    async created () {
        this.countries = [{name: 'Russia', Iso2: 'RU', Iso3: 'RUS'}]
        let new_c = await this.$store.dispatch('fetchCountries');
        this.countries = this.countries.concat(new_c)
    }
}
</script>